// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { addFilesToIntelligentInventoryThread } from "./schema/intelligent-inventory/add-files-to-intelligent-inventory-thread";
import { confirmIntelligentInventoryTool } from "./schema/intelligent-inventory/confirm-intelligent-inventory-tool";
import { getIntelligentInventoryFileDownloadUrl } from "./schema/intelligent-inventory/get-intelligent-inventory-file-download-url";
import { getIntelligentInventoryOperationDiff } from "./schema/intelligent-inventory/get-intelligent-inventory-operation-diff";
import { getIntelligentInventoryThread } from "./schema/intelligent-inventory/get-intelligent-inventory-thread";
import { getIntelligentInventoryThreadMessages } from "./schema/intelligent-inventory/get-intelligent-inventory-thread-messages";
import { listIntelligentInventoryThreads } from "./schema/intelligent-inventory/list-intelligent-inventory-threads";
import { respondToIntelligentInventoryTool } from "./schema/intelligent-inventory/respond-to-intelligent-inventory-tool";
import { saveIntelligentInventoryThread } from "./schema/intelligent-inventory/save-intelligent-inventory-thread";
import { streamIntelligentInventory } from "./schema/intelligent-inventory/stream-intelligent-inventory";
import { undoIntelligentInventoryOperation } from "./schema/intelligent-inventory/undo-intelligent-inventory-operation";
import { uploadIntelligentInventoryFile } from "./schema/intelligent-inventory/upload-intelligent-inventory-file";

export const groupJ: {
  addFilesToIntelligentInventoryThread: typeof addFilesToIntelligentInventoryThread;
  streamIntelligentInventory: typeof streamIntelligentInventory;
  uploadIntelligentInventoryFile: typeof uploadIntelligentInventoryFile;
  confirmIntelligentInventoryTool: typeof confirmIntelligentInventoryTool;
  getIntelligentInventoryThread: typeof getIntelligentInventoryThread;
  getIntelligentInventoryThreadMessages: typeof getIntelligentInventoryThreadMessages;
  listIntelligentInventoryThreads: typeof listIntelligentInventoryThreads;
  saveIntelligentInventoryThread: typeof saveIntelligentInventoryThread;
  getIntelligentInventoryFileDownloadUrl: typeof getIntelligentInventoryFileDownloadUrl;
  getIntelligentInventoryOperationDiff: typeof getIntelligentInventoryOperationDiff;
  respondToIntelligentInventoryTool: typeof respondToIntelligentInventoryTool;
  undoIntelligentInventoryOperation: typeof undoIntelligentInventoryOperation;
} = {
  addFilesToIntelligentInventoryThread,
  streamIntelligentInventory,
  uploadIntelligentInventoryFile,
  confirmIntelligentInventoryTool,
  getIntelligentInventoryThread,
  getIntelligentInventoryThreadMessages,
  listIntelligentInventoryThreads,
  saveIntelligentInventoryThread,
  getIntelligentInventoryFileDownloadUrl,
  getIntelligentInventoryOperationDiff,
  respondToIntelligentInventoryTool,
  undoIntelligentInventoryOperation,
};
